import {
  Box,
  Chip,
  Stack,
  Typography,
} from "@mui/material";

import LocalFloristIcon from "@mui/icons-material/LocalFlorist";
import ScienceIcon from "@mui/icons-material/Science";
import BiotechIcon from "@mui/icons-material/Biotech";
import VerifiedIcon from "@mui/icons-material/Verified";
import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";

function HeroBanner() {
  return (
    <Box
      sx={{
        mt: 5,
        mb: 5,
        p: {
          xs: 3,
          md: 5,
        },

        borderRadius: 6,

        position: "relative",

        overflow: "hidden",

        background:
          "linear-gradient(135deg,#FFFFFF 0%,#F6FAFC 50%,#EDF6F9 100%)",

        border: "1px solid #E3EDF3",

        boxShadow: "0 15px 35px rgba(11,60,93,.08)",
      }}
    >
      {/* Decorative Background */}

      <Box
        sx={{
          position: "absolute",
          width: 280,
          height: 280,
          borderRadius: "50%",
          bgcolor: "rgba(11,60,93,.04)",
          top: -120,
          right: -80,
        }}
      />

      <Box
        sx={{
          position: "absolute",
          width: 180,
          height: 180,
          borderRadius: "50%",
          bgcolor: "rgba(46,125,50,.05)",
          bottom: -80,
          left: -60,
        }}
      />

      <Box
        sx={{
          position: "relative",
          zIndex: 2,
        }}
      >
        {/* Heading */}

        <Stack
          direction="row"
          spacing={2}
          alignItems="center"
          mb={2}
        >
          <Box
            sx={{
              width: 60,
              height: 60,
              borderRadius: "50%",
              bgcolor: "#EEF5FA",

              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <AutoAwesomeIcon
              sx={{
                color: "#0B3C5D",
                fontSize: 32,
              }}
            />
          </Box>

          <Box>
            <Typography
              sx={{
                fontWeight: 800,
                color: "#0B3C5D",
                fontSize: {
                  xs: "1.8rem",
                  md: "2.4rem",
                },
              }}
            >
              Digital Flora Repository
            </Typography>

            <Typography
              sx={{
                color: "#607D8B",
                fontWeight: 500,
              }}
            >
              Department of Botany • School of Life Sciences
            </Typography>
          </Box>
        </Stack>

        {/* Description */}

        <Typography
          sx={{
            color: "#556270",
            lineHeight: 2,
            fontSize: {
              xs: "1rem",
              md: "1.08rem",
            },
            maxWidth: 950,
          }}
        >
          This specimen has been digitally documented with authenticated
          botanical, taxonomic, phytochemical, medicinal, ecological,
          economic, and conservation information. The Digital Flora
          Repository supports botanical research, biodiversity
          conservation, higher education, and digital herbarium
          development at Rayalaseema University.
        </Typography>

        {/* Chips */}

        <Stack
          direction="row"
          spacing={2}
          mt={4}
          flexWrap="wrap"
          useFlexGap
        >
          <Chip
            icon={<ScienceIcon />}
            label="Taxonomy"
            sx={{
              bgcolor: "#EEF5FA",
              color: "#0B3C5D",
              fontWeight: 700,
            }}
          />

          <Chip
            icon={<BiotechIcon />}
            label="Phytochemistry"
            sx={{
              bgcolor: "#EEF8F2",
              color: "#2E7D32",
              fontWeight: 700,
            }}
          />

          <Chip
            icon={<LocalFloristIcon />}
            label="Medicinal Importance"
            sx={{
              bgcolor: "#FFF6E8",
              color: "#EF6C00",
              fontWeight: 700,
            }}
          />

          <Chip
            icon={<VerifiedIcon />}
            label="Verified Botanical Record"
            sx={{
              bgcolor: "#F1F4FF",
              color: "#1565C0",
              fontWeight: 700,
            }}
          />
        </Stack>

        {/* Quote */}

        <Box
          sx={{
            mt: 5,
            pt: 3,
            borderTop: "1px solid #E4EDF2",
          }}
        >
          <Typography
            sx={{
              color: "#607D8B",
              fontStyle: "italic",
              fontSize: "1rem",
            }}
          >
            "Preserving botanical diversity through scientific
            documentation, digital innovation, and biodiversity
            conservation for future generations."
          </Typography>
        </Box>
      </Box>
    </Box>
  );
}

export default HeroBanner;